import {createContext} from "react";

export const HCP_PRESENTATION_FOOTER_HEIGHT = "5rem";
export const PROPOSAL_GENERATE_PDF = createContext(false);
export const EMBEDDED_PROPOSAL = createContext(false);
